export const injectHeadCode = (customHeadCode: string) => {
  if (!customHeadCode) return;

  const headCode = document
    .createRange()
    .createContextualFragment(customHeadCode);

  document.head.appendChild(headCode);
};
